import { useState } from "react";
import styles from 'styles/Header.module.css';
import Logo from 'assets/images/header/logo_flex_w.png';
import XLogo from 'assets/images/header/x_logo.png';
import HamburgerMenu from './HamburgerMenu';
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import LanguageSelector from "components/layouts/header/LanguageSelector";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const navigate = useNavigate();

  const handleTitleClick = () => {
    navigate("/");
  };

  return (
    <header className={styles["header"]}>
      <img src={Logo} alt="AREA CUP ロゴ" className={styles["header-logo"]} onClick={handleTitleClick} draggable="false" />
      {/* <LanguageSelector /> */}
      <Link to="/#news" className={styles["header-nav"]}>THE LATEST</Link>
      <Link to="/#about" className={styles["header-nav"]}>ABOUT</Link>
      <Link to="/#ranking" className={styles["header-nav"]}>RANKING</Link>
      <Link to="/#schedule" className={styles["header-nav"]}>SCHEDULE</Link>
      <Link to="/guideline" className={styles["header-nav"]}>GUIDELINE</Link>
      <a href="https://x.com/splatoon_zone" target="_blank" rel="noopener noreferrer" className={styles["header-nav"]}>
        <img src={XLogo} alt="X" className={styles["x-icon"]} />
      </a>
      <div className={styles["menu-container"]}>
        <div className={styles["hamburger"]} onClick={toggleMenu}>
          <div className={styles["bar"]}></div>
          <div className={styles["bar"]}></div>
          <div className={styles["bar"]}></div>
        </div>
      </div>
      <HamburgerMenu isOpen={isOpen} closeMenu={closeMenu} />
    </header>
  );
};

export default Header;
